import { render, staticRenderFns } from "./FinalFooter.vue?vue&type=template&id=e6e61330&scoped=true&lang=pug&"
import script from "./FinalFooter.vue?vue&type=script&lang=js&"
export * from "./FinalFooter.vue?vue&type=script&lang=js&"
import style0 from "./FinalFooter.vue?vue&type=style&index=0&id=e6e61330&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e61330",
  null
  
)

export default component.exports